module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "draggable",
    class: {
      draggable: true, dragging: _vm.dragging
    },
    attrs: {
      "draggable": ""
    },
    on: {
      "dragstart": function($event) {
        _vm.dragging = true;
        _vm.$emit('drag-start', _vm.setData($event))
      },
      "dragend": function($event) {
        _vm.dragging = false;
        _vm.$emit('drag-end', _vm.getData($event))
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3316932e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Draggable.vue
// module id = 256
// module chunks = 1